import MagnifyGlass from 'game/display/MagnifyGlass.js';

export function magnifyingGlassControl() {
  const scaleMin = 0.6;
  const scaleVariation = 0.75;
  let magnifyGlass;
  let events;
  let zones;

  function addMagnifyingGlass(scene, position, hotspots) {
    magnifyGlass = new MagnifyGlass(scene, 1200, 500);
    zones = [];
    hotspots.forEach((hotspotData) => {
      const x = position.x + hotspotData.x;
      const y = position.y + hotspotData.y;

      const zone = { x, y, data: hotspotData };
      zones.push(zone);
    });
    magnifyGlass.scaleMin = scaleMin;
    magnifyGlass.setScale(scaleMin);
    magnifyGlass.bounceIn();
  }

  function activateMagnifyingGlass() {
    magnifyGlass.activate();
    magnifyGlass.bouncePrompt(0);
  }

  function handleDrag(game, scene, state) {
    if (!magnifyGlass || !magnifyGlass.isDragging) return;
    const tolerance = 150;
    let distance = tolerance;
    let data = {};
    for (const zone of zones) {
      let d = Phaser.Math.Distance.Between(magnifyGlass.x, magnifyGlass.y, zone.x, zone.y);
      if (d < distance) {
        data = { wx: zone.x, wy: zone.y, ...zone.data };
        distance = d;
      }
    }
    // handle proximity
    const distanceCapped = Math.min(tolerance, distance);
    const scaleAdjust = scaleMin + (1 - distance / tolerance) * scaleVariation;
    magnifyGlass.setScale(scaleAdjust);
    if (distanceCapped < 50) {
      magnifyGlass.handleHotspotTrigger(data, false);
      scene.time.delayedCall(300, () => {
        magnifyGlass.setTalking(true);
        state.playHotSpotVO(data);
      });
    }
  }

  function handleVOComplete({ id }) {
    let isComplete = false;
    if (magnifyGlass) {
      magnifyGlass.setTalking(false);
      // remove zone
      zones = zones.filter((z) => {
        return z.data.id !== id;
      });
      if (zones.length > 0) {
        magnifyGlass.setScale(scaleMin);
        magnifyGlass.remove();
      } else {
        isComplete = true;
      }
    }
    return isComplete;
  }

  function removeMagGlass(cb, cbscope) {
    magnifyGlass.events.once('complete', cb, cbscope);
    magnifyGlass.remove();
  }

  function destroy() {
    if (magnifyGlass) {
      magnifyGlass.destroy();
      magnifyGlass = null;
    }
  }

  return {
    magnifyGlass,
    addMagnifyingGlass,
    activateMagnifyingGlass,
    handleDrag,
    handleVOComplete,
    removeMagGlass,
    destroy,
  };
}
